var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#CDF6F9;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#1A83A8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 15.792,
    cy: 17.417,
    r: 11.583
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 23.292,
    cy: 7.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.885,11.517v0.816c-2.27,0.572-2.752,1.937-2.811,2.812c-0.159,2.316,2.602,2.943,3.508,3.15   c1.387,0.315,2.144,0.761,2.131,1.253c-0.031,1.18-2.15,1.382-3.06,1.414c-0.147,0-0.205-0.057-0.243-0.092   c-0.044-0.043-0.097-0.118-0.097-0.23c0-0.497-0.403-0.899-0.9-0.899s-0.9,0.403-0.9,0.9c0,0.58,0.23,1.121,0.647,1.524   c0.401,0.387,0.923,0.597,1.479,0.597c0.025,0,0.052,0,0.078-0.001c0.059-0.002,0.11-0.011,0.168-0.014v0.571   c0,0.497,0.403,0.9,0.9,0.9s0.9-0.403,0.9-0.9v-0.821c1.78-0.454,2.789-1.463,2.826-2.902c0.038-1.485-1.149-2.513-3.53-3.056   c-1.457-0.331-2.147-0.747-2.112-1.271c0.073-1.067,1.702-1.348,3.058-1.395c0.113,0.006,0.182,0.046,0.224,0.087   c0.038,0.036,0.1,0.114,0.1,0.234c0,0.497,0.403,0.9,0.9,0.9s0.9-0.403,0.9-0.9c0-0.573-0.237-1.131-0.65-1.529   c-0.416-0.401-0.966-0.621-1.537-0.591c-0.062,0.002-0.117,0.008-0.178,0.011v-0.569c0-0.497-0.403-0.9-0.9-0.9   S14.885,11.02,14.885,11.517z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.78,13.71c-0.48,0.127-0.768,0.619-0.641,1.1c0.22,0.831,0.33,1.709,0.33,2.61   c0,5.889-4.791,10.68-10.68,10.68S5.11,23.309,5.11,17.42c0-5.831,4.557-10.522,10.374-10.681c0.497-0.014,0.889-0.427,0.875-0.924   c-0.013-0.496-0.438-0.888-0.924-0.875C8.636,5.125,3.31,10.606,3.31,17.42c0,6.882,5.599,12.48,12.48,12.48   s12.48-5.599,12.48-12.48c0-1.056-0.132-2.089-0.391-3.069C27.753,13.869,27.264,13.582,26.78,13.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M21.956,9.023c0.148,0.19,0.366,0.313,0.605,0.34c0.034,0.004,0.068,0.006,0.103,0.006   c0.204,0,0.404-0.07,0.564-0.199l2.062-1.661c0.388-0.313,0.448-0.879,0.137-1.266c-0.311-0.387-0.879-0.448-1.266-0.137   L22.81,7.195l-0.247-0.314C22.258,6.49,21.69,6.418,21.3,6.728C20.908,7.033,20.84,7.6,21.146,7.99L21.956,9.023z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.29,12.9c1.442,0,2.798-0.563,3.817-1.582c0.001,0,0.001,0,0.001,0s0,0,0-0.001   c1.02-1.02,1.582-2.375,1.582-3.817s-0.563-2.799-1.582-3.817C26.089,2.662,24.732,2.1,23.29,2.1s-2.799,0.563-3.817,1.582   C18.452,4.701,17.89,6.058,17.89,7.5s0.563,2.799,1.582,3.817C20.491,12.338,21.848,12.9,23.29,12.9z M20.745,4.954   c0.68-0.68,1.583-1.054,2.545-1.054s1.865,0.374,2.546,1.055c0.68,0.68,1.054,1.583,1.054,2.545s-0.374,1.865-1.054,2.545   c-0.001,0-0.001,0-0.001,0.001c-1.359,1.359-3.729,1.36-5.091-0.001c-0.68-0.68-1.054-1.583-1.054-2.545S20.064,5.635,20.745,4.954   z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.31fa77ef648af286a5c3fe4fc9153aa9.svg";
export { ForwardRef as ReactComponent };